<template>
  <div class="invite-rules-root" :style="cssVars()">
    <div class="page-bg"></div>
    <div class="custom-nav-block" :style="`paddingTop:${topBarHeight}px`">
      <van-nav-bar title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="../images/arrow-l.webp" alt="" />
          <!-- Rules -->
          <span class="tit-left">{{ $t('lang.BaseCommon.k005') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <div class="rules-content">
      <p class="main-title">{{ $t('lang.Invite.k069') }}</p>

      <!-- How to Invite Friends -->
      <div class="rules-section">
        <p class="section-title">{{ $t('lang.Invite.k025') }}</p>
        <ol class="rules-list">
          <li>{{ $t('lang.Invite.k026') }}</li>
          <li>{{ $t('lang.Invite.k027') }}</li>
          <li>{{ $t('lang.Invite.k028') }}</li>
          <li>
            <MyPLabel :str="$t('lang.Invite.k029')" :numsOption="[{ value: 72 }]" />
          </li>
          <li v-if="baseInfo && baseInfo.videoLimitDay">
            <MyPLabel :str="$t('lang.Invite.k044')" :numsOption="[{ value: baseInfo.videoLimitDay }]" />
          </li>
        </ol>
      </div>

      <!-- Hostess Invite Bonus -->
      <div class="rules-section" id="inviteBonus">
        <p class="section-title">{{ $t('lang.Invite.k065') }}</p>
        <ol class="rules-list">
          <li v-if="baseInfo && baseInfo.videoTimes <= 1">
            <MyPLabel
              :str="$t('lang.Invite.k030')"
              :numsOption="[
                { value: baseInfo.videoTimes || '*' },
                { value: baseInfo.videoMinSeconds || '*' },
                { value: baseInfo.videoLimitDay || '*' },
                { value: baseInfo.rewardBeans || '*' },
              ]"
            />
          </li>
          <li v-if="baseInfo && baseInfo.videoTimes > 1">
            <MyPLabel
              :str="$t('lang.Invite.k031')"
              :numsOption="[
                { value: baseInfo.videoTimes || '*' },
                { value: baseInfo.videoMinSeconds || '*' },
                { value: baseInfo.videoLimitDay || '*' },
                { value: baseInfo.rewardBeans || '*' },
              ]"
            />
          </li>
          <li>{{ $t('lang.Invite.k032') }}</li>
          <li>{{ $t('lang.Invite.k138') }}</li>
          <li>{{ $t('lang.Invite.k033') }}</li>
        </ol>
        <div class="zone-block">
          <template v-for="(item, index) in zoneList1">
            <div v-if="(!zone1ShowMore && index < 6) || zone1ShowMore" class="zone-item" :key="item.locationCode">
              <div>
                <img :src="item.locationFlag | imgPath" alt="" />
                {{ item.locationName }}
              </div>
            </div>
          </template>
        </div>
        <div v-show="zoneList1.length > 6" class="more-btn" :class="{ expanded: zone1ShowMore }" @click="zone1ShowMore = !zone1ShowMore">
          {{ $t('lang.Invite.k034') }}
          <img src="../images/arrow-r.webp" alt="" />
        </div>
      </div>

      <!-- Hostess Event Bonus -->
      <div class="rules-section" id="limitedBonus" v-if="baseInfo && baseInfo.actRewardIncome">
        <p class="section-title">{{ $t('lang.Invite.k066') }}</p>
        <ol class="rules-list">
          <li v-if="baseInfo && baseInfo.actLimitIncome && baseInfo.actLimitDay && baseInfo.actRewardIncome">
            <MyPLabel
              :str="$t('lang.Invite.k035')"
              :numsOption="[{ value: baseInfo.actLimitIncome }, { value: baseInfo.actLimitDay }, { value: baseInfo.actRewardIncome }]"
            />
          </li>
          <li>{{ $t('lang.Invite.k032') }}</li>
          <li>
            {{ $t('lang.Invite.k036') }}
            <span v-if="baseInfo">
              {{ handleMoment(baseInfo.actStartTime, 'DD/MM/YYYY') }} - {{ handleMoment(baseInfo.actEndTime, 'DD/MM/YYYY') }}
            </span>
          </li>
          <li>{{ $t('lang.Invite.k139') }}</li>
          <li>{{ $t('lang.Invite.k037') }}</li>
        </ol>
        <div class="zone-block">
          <template v-for="(item, index) in zoneList2">
            <div v-if="(!zone2ShowMore && index < 6) || zone2ShowMore" class="zone-item" :key="item.locationCode">
              <div>
                <img :src="item.locationFlag | imgPath" alt="" />
                {{ item.locationName }}
              </div>
            </div>
          </template>
        </div>
        <div v-show="zoneList2.length > 6" class="more-btn" :class="{ expanded: zone2ShowMore }" @click="zone2ShowMore = !zone2ShowMore">
          {{ $t('lang.Invite.k034') }}
          <img src="../images/arrow-r.webp" alt="" />
        </div>
      </div>

      <!-- Hostess Commission -->
      <div class="rules-section" id="commission">
        <p class="section-title">{{ $t('lang.Invite.k067') }}</p>
        <ol class="rules-list">
          <li>{{ $t('lang.Invite.k038') }}</li>
          <li>{{ $t('lang.Invite.k121') }}</li>
          <li>{{ $t('lang.Invite.k137') }}</li>
        </ol>
        <div class="commission-table-wrap">
          <div class="commission-table">
            <div class="table-header">
              <div class="th">{{ $t('lang.Invite.k063') }}</div>
              <div class="th">
                {{ $t('lang.Invite.k064') }}
                <img :src="getMatchImg('beans')" />
              </div>
              <div class="th">{{ $t('lang.Invite.k039') }}</div>
            </div>
            <div class="table-row" v-for="item in commissionNodes" :key="item.level">
              <div class="td">{{ item.level }}</div>
              <div class="td">{{ thousandthDigit(item.minBeans) }} - {{ thousandthDigit(item.maxBeans) }}</div>
              <div class="td">{{ item.levelRate }}%</div>
            </div>
          </div>
        </div>
      </div>

      <p class="main-title">{{ $t('lang.Invite.k070') }}</p>

      <!-- How to Invite Sub-agent -->
      <div class="rules-section">
        <p class="section-title">{{ $t('lang.Invite.k122') }}</p>
        <ol class="rules-list">
          <li>{{ $t('lang.Invite.k123') }}</li>
          <li>{{ $t('lang.Invite.k124') }}</li>
          <li>{{ $t('lang.Invite.k125') }}</li>
          <li>
            <MyPLabel :str="$t('lang.Invite.k126')" :numsOption="[{ value: 7 }]" />
          </li>
          <li>{{ $t('lang.Invite.k145') }}</li>
          <li>{{ $t('lang.Invite.k146') }}</li>
        </ol>
      </div>

      <!-- Sub-agent Commission -->
      <div class="rules-section" id="subAgentCommission">
        <p class="section-title">{{ $t('lang.Invite.k098') }}</p>
        <ol class="rules-list">
          <li v-if="baseInfo">
            <MyPLabel :str="$t('lang.Invite.k127')" :numsOption="[{ value: baseInfo.secondCommissionRate }]" />
          </li>
          <li v-if="baseInfo">
            <MyPLabel :str="$t('lang.Invite.k128')" :numsOption="[{ value: thousandthDigit(baseInfo.agentIncomeLimit) }]" />
          </li>
          <li>
            <MyPLabel :str="$t('lang.Invite.k129')" :numsOption="[{ value: thousandthDigit(1000) }, { value: thousandthDigit(40) }]" />
          </li>
          <li>{{ $t('lang.Invite.k130') }}</li>
        </ol>
      </div>

      <!-- Sub-agent Event Bonus -->
      <div class="rules-section" id="subAgentEventBonus">
        <p class="section-title">{{ $t('lang.Invite.k071') }}</p>
        <ol class="rules-list">
          <li>{{ $t('lang.Invite.k072') }}</li>
          <li>
            {{ $t('lang.Invite.k073') }}
          </li>
          <li>
            {{ $t('lang.Invite.k074') }}
            <span v-if="baseInfo">
              {{ handleMoment(baseInfo.subAgentActStart, 'DD/MM/YYYY') }} - {{ handleMoment(baseInfo.subAgentActEnd, 'DD/MM/YYYY') }}
            </span>
          </li>
          <li>{{ $t('lang.Invite.k075') }}</li>
        </ol>
        <div v-if="subAgentBonusNodes && subAgentBonusNodes.length" class="commission-table-wrap">
          <div class="commission-table bonus-table">
            <div class="table-header">
              <div class="th">{{ $t('lang.Invite.k147') }}</div>
              <div class="th">
                {{ $t('lang.Invite.k077') }}
                <img :src="getMatchImg('beans')" />
              </div>
            </div>
            <div class="table-row" v-for="item in subAgentBonusNodes" :key="item.hostessCount">
              <div class="td">≥ {{ thousandthDigit(item.hostessCount) }}</div>
              <div class="td">{{ thousandthDigit(item.bonus) }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Important Notice -->
      <p class="main-title">{{ $t('lang.Invite.k078') }}</p>
      <div class="rules-section">
        <ol class="rules-list">
          <li>{{ $t('lang.Invite.k079') }}</li>
          <li>{{ $t('lang.Invite.k080') }}</li>
          <li>{{ $t('lang.Invite.k140') }}</li>
          <li>{{ $t('lang.Invite.k081') }}</li>
          <li>{{ $t('lang.Invite.k082') }}</li>
          <li>{{ $t('lang.Invite.k083') }}</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import { rules2PageApi } from '@/api/invite'
import { getBaseFeature } from '@/assets/style/variable'

export default {
  data() {
    const query = this.$route.query
    return {
      topBarHeight: query.statusBarHeight || 38,
      zone1ShowMore: false,
      zoneList1: [
        // { locationCode: 'BR', locationFlag: '' }
      ],
      zone2ShowMore: false,
      zoneList2: [
        // { locationCode: 'BR', locationFlag: '' }
      ],
      commissionNodes: [],
      baseInfo: null,
      subAgentBonusNodes: [],
    }
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
    locationTarget() {
      if (this.$route.query.location) {
        const locationDom = document.getElementById(this.$route.query.location)
        locationDom && locationDom.scrollIntoView({ behavior: 'smooth' })
      }
    },
    getRules() {
      rules2PageApi().then((resData) => {
        this.baseInfo = resData
        this.zoneList1 = resData.hostLocations || []
        this.zoneList2 = resData.actHostLocations || []
        this.commissionNodes = resData.commissionNode || []
        this.subAgentBonusNodes = (resData.inviteRewardCfgList || []).map((item) => ({
          hostessCount: item.inviteCount,
          bonus: item.rewardBean,
        }))

        this.$nextTick(() => {
          this.locationTarget()
        })
      })
    },
  },
  created() {
    this.getRules()
  },
}
</script>
<style lang="scss" scoped>
.invite-rules-root {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f5efe5;

  .page-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 775px;
    background: url('~@/assets/packageAssets/views/P2_Page/Invite/default/rules-bg.webp') top center / 100% auto no-repeat;
    pointer-events: none;
  }

  .rules-content {
    position: relative;
    z-index: 1;
    flex: 1;
    width: 100%;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;

    .main-title {
      margin: 0;
      padding: 12px 16px;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-20);
      line-height: 26px;
      color: #333333;
      text-align: center;
    }

    .rules-section {
      width: 100%;
      margin-bottom: 10px;

      .section-title {
        padding: 8px 16px;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-body-20);
        color: #333333;
      }

      .rules-list {
        margin: 0;
        padding: 4px 16px;
        list-style-type: decimal;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-body-20);
        color: #666666;

        li {
          margin-bottom: 0;
          margin-left: 21px;

          .unique-bean-icon {
            width: 14px;
            height: 14px;
            display: inline-block;
            vertical-align: middle;
          }

          .color-purple {
            color: #d4a017;
          }
        }
      }

      .zone-block {
        width: 100%;
        overflow: hidden;
        padding: 0 24px;
        box-sizing: border-box;

        .zone-item {
          float: left;
          min-width: 50%;
          padding: 0 10px;
          margin-bottom: 10px;

          & > div {
            padding: 8px 10px;
            border-radius: 20px;
            background-color: #e3cda5;
            display: inline-flex;
            align-items: center;

            font-family: var(--string-font);
            font-size: var(--fs-14);
            font-weight: var(--fw-500);
            color: #925e0d;

            img {
              width: 16px;
              height: 16px;
              border-radius: 50%;
              margin-right: 6px;
            }
          }
        }
      }

      .more-btn {
        min-width: 150px;
        margin: 0 auto;
        padding: 10px 0;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-16);
        line-height: var(--lh-title-24);
        color: #d4a017;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 12px;
          height: 13px;
          margin-left: 4px;
          transform: rotateZ(90deg);
        }

        &.expanded {
          img {
            transform: rotateZ(270deg);
          }
        }
      }

      .commission-table-wrap {
        padding: 10px 16px;
      }

      .commission-table {
        width: 100%;
        border: 1px solid #d4c7b0;
        border-radius: 12px;
        overflow: hidden;
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));

        .table-header,
        .table-row {
          display: contents;
        }

        .th,
        .td {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          min-width: 0;
          padding: 10px 4px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-14);
          line-height: var(--lh-body-20);
          color: #333333;
          text-align: center;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;
          border-right: 1px solid #f5efe5;
          border-bottom: 1px solid #f5efe5;

          img {
            width: 14px;
            height: 14px;
            vertical-align: middle;
            flex-shrink: 0;
          }
        }

        .th:nth-child(3n),
        .td:nth-child(3n) {
          border-right: none;
        }

        .th {
          background: #f0e6d4;
        }

        .td {
          background: rgba(255, 255, 255, 0.5);
        }
      }

      .bonus-table {
        grid-template-columns: repeat(2, minmax(0, 1fr));

        .th:nth-child(3n),
        .td:nth-child(3n) {
          border-right: 1px solid #f5efe5;
        }

        .th:nth-child(2n),
        .td:nth-child(2n) {
          border-right: none;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.invite-rules-root {
  .custom-nav-block {
    position: relative;
    z-index: 2;
    background: transparent;
  }

  .van-nav-bar {
    background: transparent;

    .van-nav-bar__content {
      .van-nav-bar__left {
        .left-nav {
          width: 20px;
          height: 20px;
        }

        .tit-left {
          font-family: 'InterTight-Medium', var(--string-font);
          font-size: var(--fs-20);
          line-height: var(--lh-title-24);
          color: #333333;
          font-weight: var(--fw-500);
        }
      }
    }
  }
}
</style>
<style lang="scss">
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .invite-rules-root {
    .rules-section {
      .rules-list li {
        margin-left: 0;
        margin-right: 21px;
      }

      .zone-block .zone-item > div img {
        margin-left: 0;
        margin-right: 4px;
      }

      .more-btn img {
        transform: rotateZ(270deg);
      }
    }
  }
}
</style>
